var map = {
	"./bluelagoon_10_1680.png": 2246,
	"./bluelagoon_10_420.png": 9847,
	"./bluelagoon_10_980.png": 3096,
	"./bluelagoon_11_1680.png": 8658,
	"./bluelagoon_11_420.png": 1427,
	"./bluelagoon_11_980.png": 9241,
	"./bluelagoon_12_1680.png": 3237,
	"./bluelagoon_12_420.png": 459,
	"./bluelagoon_12_980.png": 802,
	"./bluelagoon_1_1680.png": 9980,
	"./bluelagoon_1_420.png": 5602,
	"./bluelagoon_1_980.png": 1766,
	"./bluelagoon_2_1680.png": 9407,
	"./bluelagoon_2_420.png": 7062,
	"./bluelagoon_2_980.png": 7738,
	"./bluelagoon_3_1680.png": 8414,
	"./bluelagoon_3_420.png": 8108,
	"./bluelagoon_3_980.png": 4814,
	"./bluelagoon_4_1680.png": 8602,
	"./bluelagoon_4_420.png": 993,
	"./bluelagoon_4_980.png": 8986,
	"./bluelagoon_5_1680.png": 719,
	"./bluelagoon_5_420.png": 8053,
	"./bluelagoon_5_980.png": 2422,
	"./bluelagoon_6_1680.png": 421,
	"./bluelagoon_6_420.png": 5521,
	"./bluelagoon_6_980.png": 1132,
	"./bluelagoon_7_1680.png": 4783,
	"./bluelagoon_7_420.png": 6923,
	"./bluelagoon_7_980.png": 1829,
	"./bluelagoon_8_1680.png": 3144,
	"./bluelagoon_8_420.png": 47,
	"./bluelagoon_8_980.png": 1310,
	"./bluelagoon_9_1680.png": 9640,
	"./bluelagoon_9_420.png": 7458,
	"./bluelagoon_9_980.png": 1918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8059;